export namespace AlarmManagementModel {
  export enum AlarmStatus {
    CANCELED = 0,
    ACTIVE = 1,
  }

  export interface AlarmData {
    id: string;
    orgId: string;
    locationId: string;
    status: AlarmStatus;
    dispatchTime: string;
    cancelTime?: string;
    cancelBy?: string;
    timezone?: string;
  }

  export interface CreateAlarm {
    locationId: string;
    uniformId?: string;
  }

  export interface CancelAlarm {
    alarmId: string;
    cancelBy: string;
  }

  export interface AlarmFilter {
    status?: AlarmStatus;
    locationId?: string;
    fromDate?: string;
    toDate?: string;
  }

  export interface AlarmCheckResponse {
    hasActiveAlarm: boolean;
    activeAlarm?: AlarmData;
  }

  // New interfaces for alert instances and Noonlight activity
  export interface AlertInstanceSummary {
    alertInstanceId: number;
    timestamp: number;
    eventId: string;
    cameraId: string;
    mainThumbnail?: string;
    routing: number;
    noonLightAlarmId?: string;
    timezone?: string;
  }

  export interface AlarmWithAlerts extends AlarmData {
    alertInstancesCount: number;
  }

  export interface NoonlightActivityLog {
    operationType: string;
    requestTimestamp: number;
    responseTimestamp?: number;
    requestDurationMs?: number;
    verified?: boolean;
    result?: string;
    dispatchEventType?: string;
    prompt?: string;
    attachmentUrl?: string;
    timezone?: string;
  }

  export interface RejectedAlert {
    alertInstanceId: string | number;
    alertId?: string;
    locationId: string;
    cameraId: string;
    eventId: string;
    timestamp: number;
    mainThumbnail?: string;
    alertMessage?: string;
    edgeId?: string;
    locationName?: string;
    cameraName?: string;
    timezone?: string;
  }

  export interface PaginatedResponse<T> {
    data: T[];
    total: number;
    limit: number;
    offset: number;
  }

  export interface RejectedAlertsFilter {
    locationId?: string;
    fromDate?: string;
    toDate?: string;
  }

  export interface PaginationParams {
    limit?: number;
    offset?: number;
  }

  export interface AlarmsWithAlertsFilter extends PaginationParams {
    status?: AlarmStatus;
    locationId?: string;
  }

  export type SelectedTab = 'active' | 'handled' | 'rejected';

  export interface AlertActivityLog {
    id: number;
    alertInstanceId: number;
    action: number;
    details?: string;
    timestamp: number;
    userId?: string;
    timezone?: string;
  }

  // Alert activity action types
  export enum AlertActivityAction {
    CREATE = 1,
    ACKNOWLEDGE = 2,
    SHARE = 3,
    ARCHIVE = 4,
    DELETE = 5,
    PUBLISH = 6,
    SEND_CALL_CENTER_IMAGE = 7,
    RESPONSE_CALL_CENTER_IMAGE = 8,
    SEND_CALL_CENTER_VIDEO = 9,
    RESPONSE_CALL_CENTER_VIDEO = 10,
    SEND_DISPATCH_REQUEST = 11,
    DISPATCH_WEBHOOK = 12,
    VCC_CHECK = 13,
    VCC_CREATE = 14,
    VCC_UPDATE = 15,
    UPDATE_ALARM_CALL_CENTER = 16,
    ADD_DISPATCH_CONTACT = 21,
  }

  export interface AlertDetailsDialogData {
    alert: RejectedAlert;
  }

  export interface ImagePreviewDialogData {
    url: string;
  }
}
